<div class="sticky-form">
<form >
	<mat-form-field appearance="outline" class="date-search" (keyup.enter)="onEnterKey()">
		<mat-label>Global Search</mat-label>
		<input matInput [formControl]="globalSearch" >
	@if (globalSearch.getRawValue()) {
    <button matSuffix matIconButton class="mat-clear" aria-label="Clear" (click)="clickGlobalSearchX($event)">
      <mat-icon>close</mat-icon>
    </button>
  }
	</mat-form-field>

	<mat-paginator (page)="onPageChange($event)" [length]="100" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]"
		aria-label="Select page">
	</mat-paginator>

</form>
</div>
